export default __webpack_public_path__ + "static/media/bell_long.8e6b4875.mp3";